import { createAction } from 'redux-actions';

export const requestMarkNotificationAsReadAction = createAction(
  'REQUEST/MARK_NOTIFICATION_AS_READ',
);
export const requestMarkNotificationAsClearedAction = createAction(
  'REQUEST/MARK_NOTIFICATION_AS_CLEARED',
);
export const requestMarkNotificationToggleAction = createAction(
  'REQUEST/MARK_NOTIFICATION_AS_TOGGLE',
);

export const requestGetNotificationAction = createAction('REQUEST/GET_NOTIFICATION');
export const emptyNotificationAction = createAction('REQUEST/EMPTY_NOTIFICATION');
